// import { gsap } from 'gsap';

let footerEllipseTL, footerImgTL, footerImgSecondTL;

window.footerGradientGSAPAnimation = function () {
  const imgContainer = document.querySelector('.footer-bg__bg-decor-ellipses');
  const main = document.querySelector('.main');

  if (!imgContainer || !main) return;

  if (window.innerWidth > 1024) {
    imgContainer.getBoundingClientRect();

    requestAnimationFrame(() => {
      const img = imgContainer.querySelector(
        '.footer-bg__bg-decor-ellipse-img:nth-child(1)'
      );
      const imgSecond = imgContainer.querySelector(
        '.footer-bg__bg-decor-ellipse-img:nth-child(2)'
      );

      gsap.set(imgContainer, {
        xPercent: 0,
        yPercent: -50,
        x: 0,
        y: 0,
        transformOrigin: 'center center',
      });

      footerEllipseTL = gsap.to(imgContainer, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      footerImgTL = gsap.to(img, {
        rotation: -360,
        ease: 'none',
        repeat: -1,
        duration: 30,
      });

      footerImgSecondTL = gsap.to(imgSecond, {
        rotation: 360,
        ease: 'none',
        repeat: -1,
        duration: 40,
      });
    });
  }
};

window.pauseFooterGradientAnimation = function pauseFooterGradientAnimation() {
  if (window.innerWidth > 1024) {
    footerEllipseTL?.pause();
    footerImgTL?.pause();
    footerImgSecondTL?.pause();
  }
};

window.resumeFooterGradientAnimation =
  function resumeFooterGradientAnimation() {
    if (window.innerWidth > 1024) {
      footerEllipseTL?.play();
      footerImgTL?.play();
      footerImgSecondTL?.play();
    }
  };

footerGradientGSAPAnimation();

if (!document.querySelector('.bold-loader-new')) {
  pauseFooterGradientAnimation();
}
